import React from 'react'
 //import '../css/services.css'
import ServicesCard from '../components/ServicesCard';
 function Services() {
  return (
    <div class=" services" id="Services">
      <div class="p-3 ">
      <div class="text-dark fs-2 text-center my-5">
         Our Services
        </div>
      </div>  
      <div id="container1 bg-transparent"  >
      <div  class="p-3 " >    
  <div class="row py-5 my-3 " > 
  <div class="  d-flex align-items-center col-sm-12 col-md-6 col-lg-6  ">
  <div class="">
  <p class="text-start fs-1 text-black">Empowering your digital presence <br/> with innovative web solutions.</p>
  </div> 
</div>
<div class=" col-sm-12 col-md-6 col-lg-6">
  <div>
  <p class="text-start fs-5   text-black">
  {/* we specialize in providing custom software solutions to meet the unique needs of our clients. Our team of experienced software developers can work with you to develop software that is tailored to your specific requirements and designed to meet your business goals.
Our software development services :  */}

To satisfy the specific requirements of our clients, we specialise in developing custom software solutions. With your help, our skilled team of software developers can create custom software that is made to match your needs and your company's objectives.
   </p>
  </div> 
</div>
</div>
</div>
<div  class="p-3 " >
<div class=" row  " >
  <div class=" col-sm-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center">
<ServicesCard img="/assets/webdev1.png" title="Web Development" description="react/ html" />
  </div>
  <div class=" col-sm-12 col-md-4 col-lg-4 d-flex justify-content-center align-items-center ">
<ServicesCard img="/assets/DigitalM.png" title="Digital Marketing"/>
  </div>
  <div class=" col -sm-12 col-md-4 col-lg-4 d-flex justify-content-center  align-items-center">
<ServicesCard img="/assets/android12.png" title="App Development" description=" react native and flutter"/>
  </div>
</div>
</div>
        </div>            
<div  class="bg-white p-3 " id="container2">
      <div class="py-4"  >
      <div class="row g-3 " data-aos="zoom-in-up"  data-aos-easing="ease-out-cubic"
     data-aos-duration="1000">
       <div class=" col-md-6 col-lg-6  " >
          <div class="d-flex  "
          // justify-content-center
           >
          <img src="/assets/wevdev.svg" class=" img-service img-fluid  " alt="test image"  />   
          </div>          
        </div>       
        <div class=" col-sm-12 col-md-6 col-lg-6  d-flex align-items-center p-3" >
          <div>
          <div>
          <p  class=" fs-1 text-black ">Web devlopement</p>
          </div>
         <div>
          <p  class=" fs-5  text-black ">
          {/* we offer customized web development services to businesses of all sizes. Our team of experienced developers and designers work together to create websites that are not only visually appealing but also intuitive and user-friendly.
We use the latest technologies and development frameworks to build robust and scalable websites. Our team is proficient in programming languages such as HTML, CSS, JavaScript, PHP, and Python, and we stay up-to-date with the latest trends and technologies in web development.
We also understand the importance of user experience in web development. That's why we put a lot of effort into designing a user interface that is visually appealing and easy to navigate. Our team conducts rigorous testing and quality assurance checks to ensure that your website performs flawlessly.
Whether you need a simple website or a complex one, we have the expertise and experience to bring your vision to life. Contact us today to learn more about our web development services and how we can help you take your business to the next level.          */}
We provide organisations of all sizes with specialised web development services. Our skilled team of developers and designers collaborate to produce websites that are not only aesthetically pleasing but also simple to use and intuitive.
To create reliable and scalable websites, we employ the most recent technology and development frameworks. Our team is proficient in programming languages like  HTML, CSS, JavaScript, PHP, and Python, and we stay up-to-date with the latest trends and technology in web development.
We are aware of how crucial user experience is when developing websites. We worked very hard to create a user interface that is both aesthetically pleasing and simple to use. Our staff puts your website through rigorous testing and quality assurance inspections to make sure it runs without a hitch.
         </p>
         </div>
          </div>      
        </div>
      </div>
         </div>
          <div class=" py-4"  >
      <div class="row g-3 "  data-aos="zoom-in-up"  data-aos-easing="ease-out-cubic"
     data-aos-duration="1500">
      <div class=" col-sm-12 col-md-6 col-lg-6 d-flex align-items-center p-3" >
        <div>
        <div>
          <p  class=" fs-1  text-black ">Digital Marketing</p>
          </div>
         <div>
        </div>
 
          <p  class=" fs-5  text-black ">
{/* we offer a range of services designed to help businesses grow their online presence and increase their ROI. Our team of experts specializes in various digital marketing strategies, including search engine optimization (SEO), pay-per-click advertising (PPC), social media marketing, email marketing, content marketing, and more.
Our digital marketing approach starts with a thorough analysis of your business, your industry, and your target audience. We use this information to create a customized strategy that's tailored to your business's unique needs and goals. We work closely with our clients to ensure that they are involved in every step of the process and that their vision is reflected in the final product.
We understand that every business is unique, which is why we offer customized solutions that are tailored to meet your specific needs. We are committed to delivering high-quality digital marketing services that drive results and help our clients achieve their business objectives.
In today's digital age, it's more important than ever to have a strong online presence. Let our digital marketing experts help you take your business to the next level. */}

We provide a variety of services aimed at assisting companies in expanding their online presence and boosting ROI. Search engine optimization (SEO), pay-per-click (PPC), social media marketing, email marketing, content marketing, and other digital marketing techniques are among the specialties of our team of professionals.
Our approach to digital marketing begins with a careful examination of your company, sector, and target market. With this data, we design a strategy that is unique to your company's requirements and objectives. To make sure that they are involved in every step of the process and that their vision is reflected in the finished product, we work closely with our clients.

Because we understand that every business is different, we provide tailored solutions according to your needs.
         </p>
         </div>
        </div>
        <div class="col-sm-12 col-md-6 col-lg-6 d-flex  justify-content-center align-items-center" >          
            <div class=" d-flex">
            <img src="/assets/DigitalM.png " class=" img-service  img-fluid " alt="test image"   />   
            </div>         
        </div>        
      </div>
         </div>
         <div class="py-4" >
      <div class="row g-3"  data-aos="zoom-in-up"  data-aos-easing="ease-out-cubic"
     data-aos-duration="1500">
        <div class=" col-md-6 col-lg-6 d-flex  justify-content-center align-items-center" >
          <div class=" d-flex ">
          <img src="../assets/android1.png" class=" img-service img-fluid " alt="test image" />   
          </div>
          
        </div>
        <div class=" col-md-6 col-lg-6  d-flex align-items-center p-3" >
          <div>
          <div>
          <p  class=" fs-1   text-black ">App Development</p>
          </div>
         <div>
          <p  class=" fs-5 text-black ">
          {/* we specialize in developing customized mobile applications for businesses of all sizes. Our team of experienced developers and designers work together to create apps that are not only visually appealing but also intuitive and user-friendly.
 Our team works closely with you to identify the features and functionalities you need in your app, as well as any challenges or obstacles that may arise during development. This collaborative approach ensures that we develop an app that meets your business needs and exceeds your expectations.
We use the latest technologies and development frameworks like <span class="fw-bold">React Native </span> and <span  class=" fw-bold">Flutter</span>  to build robust and scalable mobile apps for iOS and Android platforms. Our team is proficient in programming languages such as Dart, Java, and python, and we stay up-to-date with the latest trends and technologies in mobile app development.
We also understand the importance of user experience in mobile app development. That's why we put a lot of effort into designing a user interface that is visually appealing and easy to navigate. Our team conducts rigorous testing and quality assurance checks to ensure that your app performs flawlessly.
Our mobile app development services are designed to help you achieve your business objectives and reach your target audience.
Contact us today to learn more about our mobile app development services and how we can help you take your business to the next level. */}

For companies of all sizes, we specialise in creating customised mobile applications. Our skilled team of programmers and designers collaborate to produce applications that are not only aesthetically pleasing but also simple to use.
Our staff collaborates closely with you to determine the features and functionalities your app must have, as well as any difficulties or roadblocks that might appear when they are being developed. By working together, we can create an app that exceeds your expectations while also meeting your company's requirements.

We create reliable and scalable mobile apps for the iOS and Android platforms using the most recent technologies and development frameworks, such as React Native and Flutter. Our crew is knowledgeable in a variety of programming languages, including Python, Java, and Dart.
         </p>
         </div>
          </div>

        </div>
      </div>
         </div> 
     
  </div>
</div>
  )
}
export default  Services;